import { filterArraysFromPreviousStepData, convertSimpleTypeArrayToObjectArray } from '@/utils/helpers';

export default {
	methods: {
		exampleRow(previousStepsData, selectedPath) {
			const filteredPreviousStepData = filterArraysFromPreviousStepData(previousStepsData);
			const exampleRows = filteredPreviousStepData[selectedPath];
			if (Array.isArray(exampleRows) && exampleRows.length > 0) {
				return convertSimpleTypeArrayToObjectArray(exampleRows)[0];
			}
			return {};
		},
	},
};
